import { FC, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { Grid, Paper } from '@mui/material';
import { Receipt } from '@mui/icons-material';

import ErrorMessage from '../../sharedModules/layout/ErrorMessage';
import LoadingWrapper from '../../sharedModules/layout/LoadingWrapper';
import PageHeader from '../../sharedModules/layout/PageHeader';
import SpotQuotePhotoGrid from '../components/SpotQuotePhotoGrid';

import axios from '../../sharedModules/utils/axios.utils';

const rawPanelStyle = { padding: 16, whiteSpace: 'pre-wrap' as const, wordBreak: 'break-word' as const };

const SpotQuoteDetailPage: FC = () => {
  const { xoiJobId } = useParams<{ xoiJobId: string }>();

  const [errorMessage, setErrorMessage] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [xoiJob, setXoiJob] = useState<any>();

  const fetchXoiJob = async () => {
    setLoading(true);
    try {
      const response: any = await axios.get(`/spot_quotes/xoi_jobs/${xoiJobId}`);
      setXoiJob(response.data);
      setErrorMessage('');
    } catch (error) {
      setErrorMessage('Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchXoiJob();
  }, []);

  return (
    <Grid container>
      <Grid item xs={12}>
        <ErrorMessage message={errorMessage} />
      </Grid>
      <Grid item xs={12}>
        <LoadingWrapper isLoading={loading}>
          <PageHeader
            titleIcon={<Receipt />}
            mainTitle={xoiJob?.customer_name}
            subTitle={xoiJob?.work_order_number}
            backButtonLabel="Spot Quotes"
            backButtonLink="/spot_quotes"
          />
        </LoadingWrapper>
      </Grid>
      <Grid item xs={12} style={{ marginTop: 10 }}>
        <Paper style={{ padding: 16 }}>
          <p>
            <strong>Location:</strong> {xoiJob?.job_location}
          </p>
          <p>
            <strong>Completed:</strong> {xoiJob?.completed_at_with_time}
          </p>
          <p>
            <strong>Flagged for Spot Quote:</strong> {xoiJob?.spot_quote_flagged_at_with_time}
          </p>
        </Paper>
      </Grid>
      <Grid item xs={12} style={{ marginTop: 10 }}>
        <Paper style={{ padding: 16 }}>
          <SpotQuotePhotoGrid photos={xoiJob?.photos} />
        </Paper>
      </Grid>
      {/* Near-raw dumps of the XOI sub-object data — unshaped while we're still eyeballing what's useful here. */}
      <Grid item xs={12} style={{ marginTop: 10 }}>
        <Paper style={rawPanelStyle}>
          <h4>Documentation ({xoiJob?.documentation?.length || 0})</h4>
          <pre>{JSON.stringify(xoiJob?.documentation, null, 2)}</pre>
        </Paper>
      </Grid>
      <Grid item xs={12} style={{ marginTop: 10 }}>
        <Paper style={rawPanelStyle}>
          <h4>Assignees</h4>
          <pre>{JSON.stringify(xoiJob?.assignees, null, 2)}</pre>
        </Paper>
      </Grid>
      <Grid item xs={12} style={{ marginTop: 10, marginBottom: 10 }}>
        <Paper style={rawPanelStyle}>
          <h4>Support Statuses</h4>
          <pre>{JSON.stringify(xoiJob?.support_statuses, null, 2)}</pre>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default SpotQuoteDetailPage;
